import { styled } from '@vw-marketing/us-components';

export const StyledCloseButtonContainer = styled.div`
  padding: 10px;
  display: flex;
  width: 100%;
  justify-content: end;

  button {
    background: #dfe4e8;
    border-radius: 32px;
  }
`;
